export default "__VITE_ASSET__CYjtXsz7__"